"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var play_api_1 = require("@l2p/play-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Congrats_1 = __importDefault(require("./components/Congrats"));
var CurveText_1 = __importDefault(require("./components/CurveText"));
var Roulette_1 = __importDefault(require("./components/Roulette"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useAnimation_1 = __importDefault(require("./useAnimation"));
var useTimer_1 = __importDefault(require("./useTimer"));
var initialPrizes = [
    { id: 'bonus150', active: false, degree: 120 },
];
var getWheelSections = function (data, currentCurrency) {
    var wheelSections = data === null || data === void 0 ? void 0 : data.map(function (reward, i) {
        var _a, _b, _c, _d;
        var value = 0;
        var description = '';
        var position = 0;
        var type = '';
        if ((reward === null || reward === void 0 ? void 0 : reward.type) === play_api_1.WheelRewardType.Cash) {
            value = (_b = (_a = reward === null || reward === void 0 ? void 0 : reward.cashAmount) === null || _a === void 0 ? void 0 : _a.find(function (ca) { return ca.currency === currentCurrency; })) === null || _b === void 0 ? void 0 : _b.amount;
            description = currentCurrency;
            type = play_api_1.WheelRewardType.Cash;
        }
        if ((reward === null || reward === void 0 ? void 0 : reward.type) === play_api_1.WheelRewardType.Bonus) {
            (_d = (_c = reward.bonus) === null || _c === void 0 ? void 0 : _c.rewards) === null || _d === void 0 ? void 0 : _d.forEach(function (bonusReward) {
                var _a;
                if (bonusReward.type === play_api_1.BonusRewardType.FreeRounds &&
                    bonusReward.freeRoundsCount) {
                    value = bonusReward.freeRoundsCount || 0;
                    description = 'FS';
                    type = play_api_1.BonusRewardType.FreeRounds;
                }
                if (bonusReward.type === play_api_1.BonusRewardType.Absolute &&
                    bonusReward.addedToBalance) {
                    value =
                        ((_a = bonusReward.addedToBalance.find(function (ca) { return ca.currency === currentCurrency; })) === null || _a === void 0 ? void 0 : _a.amount) || 0;
                    description = currentCurrency;
                    type = play_api_1.BonusRewardType.Absolute;
                }
            });
        }
        if (reward === null || reward === void 0 ? void 0 : reward.position) {
            position = reward.position;
        }
        else {
            position = i;
        }
        return {
            id: (reward === null || reward === void 0 ? void 0 : reward.id) || "".concat(i),
            value: value,
            type: type,
            description: description,
            position: position,
        };
    });
    return wheelSections;
};
var Wheel = function () {
    var _a;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var _b = (0, swr_hooks_1.useGetWheel)(), data = _b.data, isLoading = _b.isLoading, isValidating = _b.isValidating;
    var t = (0, next_intl_1.useTranslations)('wheel');
    var _c = (0, react_1.useState)(0), spins = _c[0], setSpins = _c[1];
    var _d = (0, react_1.useState)(null), nextSpinDate = _d[0], setNextSpinDate = _d[1];
    var _e = (0, react_1.useState)(), condition = _e[0], setCondition = _e[1];
    var _f = (0, react_1.useState)(), wheelSections = _f[0], setWheelSections = _f[1];
    var _g = (0, react_1.useState)(false), isRolling = _g[0], setRolling = _g[1];
    var _h = (0, react_1.useState)(initialPrizes), prizes = _h[0], setPrizes = _h[1];
    var _j = (0, react_1.useState)(false), isOpenCograts = _j[0], setIsOpenCongrats = _j[1];
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var wheel = data === null || data === void 0 ? void 0 : data[0];
        if (!isLoading && wheel) {
            var wheelSectionsData = getWheelSections(wheel.rewards, currentCurrency);
            var degree_1 = 360 / wheelSectionsData.length;
            var prizesData = wheelSectionsData.map(function (w, i) { return (__assign(__assign({}, w), { active: false, degree: 360 - degree_1 * i })); });
            var condition_1;
            var wheelCondition = (_a = wheel === null || wheel === void 0 ? void 0 : wheel.conditions) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.type === play_api_1.WheelConditionType.MinDeposit; });
            if (wheelCondition) {
                condition_1 = (_b = wheelCondition === null || wheelCondition === void 0 ? void 0 : wheelCondition.minDeposit) === null || _b === void 0 ? void 0 : _b.find(function (c) { return c.currency === currentCurrency; });
            }
            setWheelSections(wheelSectionsData);
            setPrizes(prizesData);
            setSpins(wheel.ticketsAmount);
            if (wheel.nextSpinDate) {
                setNextSpinDate(wheel.nextSpinDate);
            }
            setCondition(condition_1);
        }
    }, [isLoading, isValidating]);
    var animateRoulette = (0, useAnimation_1.default)().animateRoulette;
    var _k = (0, swr_hooks_1.useMakeSpin)({
        successAction: function (res) { return __awaiter(void 0, void 0, void 0, function () {
            var prizesWithActive;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prizesWithActive = prizes.map(function (prize) {
                            if (prize.id === res.data.wheel.makeSpin.reward.baseWheelRewardId) {
                                return __assign(__assign({}, prize), { active: true });
                            }
                            return __assign(__assign({}, prize), { active: false });
                        });
                        setRolling(true);
                        return [4 /*yield*/, animateRoulette({ prizes: prizesWithActive })];
                    case 1:
                        _a.sent();
                        setRolling(false);
                        if (res.data.wheel.makeSpin.nextSpinDate) {
                            setNextSpinDate(res.data.wheel.makeSpin.nextSpinDate);
                        }
                        setPrizes(prizesWithActive);
                        setSpins(spins - 1);
                        return [2 /*return*/];
                }
            });
        }); },
    }), makeSpin = _k.makeSpin, isSubmitting = _k.isSubmitting;
    var _l = (0, useTimer_1.default)(nextSpinDate), nextSpinTime = _l.time, hasTime = _l.hasTime;
    // const customSpin = async () => {
    //   const prizesWithActive = prizes.map((prize, i) => {
    //     if (i === 0) {
    //       return { ...prize, active: true }
    //     }
    //     return { ...prize, active: false }
    //   })
    //   setRolling(true)
    //   await animateRoulette({ prizes: prizesWithActive })
    //   setRolling(false)
    //   setPrizes(prizesWithActive)
    // }
    var activatePrize = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(spins > 0)) return [3 /*break*/, 2];
                    setPrizes(prizes.map(function (p) { return (__assign(__assign({}, p), { active: false })); }));
                    return [4 /*yield*/, makeSpin({ baseWheelId: (data === null || data === void 0 ? void 0 : data[0].id) || '' })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [animateRoulette, data, spins]);
    var activePrize = (0, react_1.useMemo)(function () {
        return prizes.find(function (prize) { return prize.active; });
    }, [prizes]);
    (0, react_1.useEffect)(function () {
        if (activePrize) {
            setIsOpenCongrats(true);
        }
    }, [activePrize]);
    if (!(data === null || data === void 0 ? void 0 : data[0]) && isLoading)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                isOpenCograts && (react_1.default.createElement(Congrats_1.default, { prize: activePrize, onClose: function () { return setIsOpenCongrats(false); } })),
                react_1.default.createElement(Roulette_1.default, { wheelSections: wheelSections }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.curveText },
                    react_1.default.createElement(CurveText_1.default, { text: t('modalRibbonTitle') })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.descr, dangerouslySetInnerHTML: {
                        __html: t.raw("modalText"),
                    } }),
                isAuth && nextSpinDate && hasTime ? (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.spinButton, " ").concat(styles_module_scss_1.default.beAvailable) },
                    react_1.default.createElement("span", null, t('beAvailable')),
                    react_1.default.createElement("div", null,
                        nextSpinTime.days && !Number.isNaN(nextSpinTime.days)
                            ? "".concat(nextSpinTime.days, ":")
                            : '',
                        nextSpinTime.hours && !Number.isNaN(nextSpinTime.hours)
                            ? "".concat(nextSpinTime.hours, ":")
                            : '',
                        nextSpinTime.minutes && !Number.isNaN(nextSpinTime.minutes)
                            ? "".concat(nextSpinTime.minutes, ":")
                            : '',
                        nextSpinTime.seconds && !Number.isNaN(nextSpinTime.seconds)
                            ? "".concat(nextSpinTime.seconds)
                            : ''))) : spins > 0 ? (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.spinButton, " ").concat(spins <= 0 ? styles_module_scss_1.default.spinButtonDisabled : '', " ").concat(isRolling || isSubmitting || spins < 0 ? styles_module_scss_1.default.rolling : ''), onClick: function () {
                        !isRolling && !isSubmitting && spins > 0 && activatePrize();
                    } },
                    react_1.default.createElement("div", null, isRolling || isSubmitting ? t('wait') : t('spin')),
                    react_1.default.createElement("span", null,
                        spins,
                        " / ", (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 :
                        _a.ticketsAmount))) : (react_1.default.createElement("div", { onClick: function () {
                        return openDeposit("back=".concat(encodeURIComponent(window.location.href)));
                    }, className: "".concat(styles_module_scss_1.default.spinButton, " ").concat(styles_module_scss_1.default.required) },
                    react_1.default.createElement("span", null, t('depositRequired')),
                    condition && (react_1.default.createElement("div", null, "".concat(condition === null || condition === void 0 ? void 0 : condition.amount, " ").concat(condition === null || condition === void 0 ? void 0 : condition.currency))))),
                !isAuth && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.spinButton, " ").concat(styles_module_scss_1.default.sign), onClick: function () {
                        return openSignIn("back=".concat(encodeURIComponent(window.location.href)));
                    } },
                    react_1.default.createElement("div", null, t('spin'))))))));
};
exports.default = Wheel;
